import { ActionTree } from 'vuex';
import { Store } from '@/store/types';
import { Medium } from '@/domain/types';
import { ProductSearchState, GetProductIdentificationsByEANQuery, ProductIdentification, GetProductIdentificationQuery, ProductMasterData, ProductRawImport, GetProductRawImportQuery, GetProductMasterDataQuery, GetProductDataDistributionQuery, ProductDataDistribution, GetProductOrdersQuery, ProductOrders, GetProductRelatedCalendarsQuery, GetProductIdentificationsByProjectNumberQuery, GetProductRelatedSPPsQuery, RescheduleJobCommand } from '../types';
import { getProductDataDistribution, getProductIdentification, getProductIdentificationsByEAN, getProductIdentificationsByProjectNumber, getProductMasterData, getProductOrders, getProductRawImport, getProductRelatedCalendars, getProductRelatedSPPs, rescheduleJob } from '../service';

export const productSearchActions: ActionTree<ProductSearchState, Store> = {

  // -- Queries

  getProductIdentificationsByEAN({ commit, rootState }, query: GetProductIdentificationsByEANQuery): Promise<void> {
    commit('updateLastSearchTerm', query.ean);
    commit('getProductIdentificationsByEANStarted');
    return getProductIdentificationsByEAN(query)
      .then((productIdentifications: ProductIdentification[]) => {
        commit('getProductIdentificationsByEANSucceeded', productIdentifications);
      })
      .catch((error) => {
        commit('getProductIdentificationsByEANFailed');
        return Promise.reject(error);
      });
  },

  getProductIdentificationsByProjectNumber({ commit, rootState }, query: GetProductIdentificationsByProjectNumberQuery): Promise<void> {
    commit('updateLastSearchTerm', query.projectNumber);
    commit('getProductIdentificationsByProjectNumberStarted');
    return getProductIdentificationsByProjectNumber(query)
      .then((productIdentifications: ProductIdentification[]) => {
        commit('getProductIdentificationsByProjectNumberSucceeded', productIdentifications);
      })
      .catch((error) => {
        commit('getProductIdentificationsByProjectNumberFailed');
        return Promise.reject(error);
      });
  },

  getProductIdentification({ commit, state }): Promise<void> {
    commit('getProductIdentificationStarted');
    const query: GetProductIdentificationQuery = {
      productId: state.currentProductId!,
    };
    return getProductIdentification(query)
      .then((productIdentification: ProductIdentification) => {
        commit('getProductIdentificationSucceeded', productIdentification);
      })
      .catch((error) => {
        commit('getProductIdentificationFailed');
        return Promise.reject(error);
      });
  },

  getProductMasterData({ commit, state }): Promise<void> {
    commit('getProductMasterDataStarted');
    const query: GetProductMasterDataQuery = {
      productId: state.currentProductId!,
    };
    return getProductMasterData(query)
      .then((productMasterData: ProductMasterData) => {
        commit('getProductMasterDataSucceeded', productMasterData);
      })
      .catch((error) => {
        commit('getProductMasterDataFailed');
        return Promise.reject(error);
      });
  },

  getProductDataDistribution({ commit, state }): Promise<void> {
    commit('getProductDataDistributionStarted');
    const query: GetProductDataDistributionQuery = {
      productId: state.currentProductId!,
    };
    return getProductDataDistribution(query)
      .then((productDataDistribution: ProductDataDistribution) => {
        commit('getProductDataDistributionSucceeded', productDataDistribution);
      })
      .catch((error) => {
        commit('getProductDataDistributionFailed');
        return Promise.reject(error);
      });
  },

  getProductOrders({ commit, state }): Promise<void> {
    commit('getProductOrdersStarted');
    const query: GetProductOrdersQuery = {
      productId: state.currentProductId!,
    };
    return getProductOrders(query)
      .then((productOrders: ProductOrders) => {
        commit('getProductOrdersSucceeded', productOrders);
      })
      .catch((error) => {
        commit('getProductOrdersFailed');
        return Promise.reject(error);
      });
  },

  getProductRelatedCalendars({ commit, state }, medium: Medium): Promise<void> {
    commit('getProductRelatedCalendarsStarted');
    const query: GetProductRelatedCalendarsQuery = {
      productId: state.currentProductId!,
      medium,
    };
    return getProductRelatedCalendars(query)
      .then((productRelatedCalendars) => {
        commit('getProductRelatedCalendarsSucceeded', productRelatedCalendars);
      })
      .catch((error) => {
        commit('getProductRelatedCalendarsFailed');
        return Promise.reject(error);
      });
  },

  getProductRelatedSPPs({ commit, state }, medium: Medium): Promise<void> {
    commit('getProductRelatedSPPsStarted');
    const query: GetProductRelatedSPPsQuery = {
      productId: state.currentProductId!,
      medium,
    };
    return getProductRelatedSPPs(query)
      .then((productRelatedSPPs) => {
        commit('getProductRelatedSPPsSucceeded', productRelatedSPPs);
      })
      .catch((error) => {
        commit('getProductRelatedSPPsFailed');
        return Promise.reject(error);
      });
  },

  getProductRawImport({ commit, state }): Promise<void> {
    commit('getProductRawImportStarted');
    const query: GetProductRawImportQuery = {
      productId: state.currentProductId!,
    };
    return getProductRawImport(query)
      .then((productRawImport: ProductRawImport) => {
        commit('getProductRawImportSucceeded', productRawImport);
      })
      .catch((error) => {
        commit('getProductRawImportFailed');
        return Promise.reject(error);
      });
  },

  // -- Commands

  rescheduleJob({ commit, dispatch, state }, command: RescheduleJobCommand): Promise<void> {
    commit('rescheduleJobStarted');
    return rescheduleJob(command)
      .then(() => dispatch('getProductDataDistribution'))
      .then(() => commit('rescheduleJobSucceeded'))
      .catch((error) => {
        commit('rescheduleJobFailed');
        return Promise.reject(error);
      });
  },

};
